(() => {
  const SELECTOR = '[data-basko-collection-promo]';

  function currentPage() {
    const value = Number(new URLSearchParams(window.location.search).get('page') || 1);
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  function positionPromos(root = document) {
    const scope = root.querySelectorAll ? root : document;
    const grids = new Set();

    scope.querySelectorAll(SELECTOR).forEach((promo) => {
      const grid = promo.closest('#product-grid');
      if (grid) grids.add(grid);
    });

    grids.forEach((grid) => {
      const products = Array.from(grid.children).filter(
        (item) => item.matches('li.grid__item') && !item.matches(SELECTOR)
      );
      const promos = Array.from(grid.querySelectorAll(':scope > ' + SELECTOR));
      const lastPromoAtPosition = new Map();

      promos
        .sort((a, b) => Number(a.dataset.baskoPromoPosition || 1) - Number(b.dataset.baskoPromoPosition || 1))
        .forEach((promo) => {
          const firstPageOnly = promo.dataset.baskoFirstPageOnly === 'true';
          promo.hidden = firstPageOnly && currentPage() > 1;
          if (promo.hidden || !products.length) return;

          const requestedPosition = Math.max(1, Number(promo.dataset.baskoPromoPosition || 1));
          const productIndex = Math.min(requestedPosition, products.length) - 1;
          const insertionPoint = lastPromoAtPosition.get(productIndex) || products[productIndex];
          insertionPoint.insertAdjacentElement('afterend', promo);
          lastPromoAtPosition.set(productIndex, promo);
        });
    });
  }

  function applyButtonStyle(promo) {
    const style = promo.dataset.baskoButtonStyle || 'filled';
    promo.querySelectorAll('.basko-collection-promo__button').forEach((button) => {
      button.className = 'basko-collection-promo__button';
      if (style === 'underlined') {
        button.classList.add('basko-collection-promo__button--underlined');
      } else {
        button.classList.add('button', style === 'outline' ? 'button--secondary' : 'button--primary');
      }
    });
  }

  function buildDots(promo, slides) {
    const container = promo.querySelector('[data-basko-promo-dots]');
    if (!container) return [];

    container.replaceChildren();
    container.hidden = slides.length < 2;
    if (slides.length < 2) return [];

    return slides.map((slide, index) => {
      slide.setAttribute('aria-label', String(index + 1) + ' of ' + String(slides.length));
      const dot = document.createElement('button');
      dot.className = 'basko-collection-promo__dot';
      dot.type = 'button';
      dot.dataset.baskoPromoDot = String(index);
      dot.setAttribute('aria-label', 'Show slide ' + String(index + 1));
      dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
      container.appendChild(dot);
      return dot;
    });
  }

  function initPromo(promo) {
    if (promo.dataset.baskoPromoReady === 'true' || promo.hidden) return;

    const track = promo.querySelector('[data-basko-promo-track]');
    const slides = Array.from(promo.querySelectorAll('[data-basko-promo-slide]'));
    if (!track || !slides.length) return;

    const dots = buildDots(promo, slides);
    applyButtonStyle(promo);
    promo.dataset.baskoPromoReady = 'true';

    let activeIndex = 0;
    let visible = false;
    let frame;

    const setVideoState = () => {
      slides.forEach((slide, index) => {
        const video = slide.querySelector('video');
        const autoplay = slide.querySelector('[data-basko-video-autoplay]');
        if (!video || !autoplay) return;

        if (visible && index === activeIndex) {
          video.muted = true;
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    };

    const setActive = (index) => {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      dots.forEach((dot, dotIndex) => {
        dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
      });
      setVideoState();
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.baskoPromoDot || 0);
        if (slides[index]) {
          slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
      });
    });

    track.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          setActive(index);
        });
      },
      { passive: true }
    );

    const observer = new IntersectionObserver(
      (entries) => {
        visible = entries[0] ? entries[0].isIntersecting : false;
        setVideoState();
      },
      { threshold: 0.15 }
    );
    observer.observe(promo);

    setActive(0);
  }

  function init(root = document) {
    positionPromos(root);
    root.querySelectorAll(SELECTOR).forEach(initPromo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest ? event.target.closest('[data-basko-promo-slide]') : null;
    if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  });
})();
